import { render } from "./alpha.vue?vue&type=template&id=107b85c4"
import script from "./alpha.vue?vue&type=script&lang=js"
export * from "./alpha.vue?vue&type=script&lang=js"

import "./alpha.vue?vue&type=style&index=0&id=107b85c4&lang=css"
script.render = render

export default script